@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.eventList {
  font-style: normal;
  padding-left: 25px;

  &.notAvailable {
    color: v.$palette-gray-900;
    text-align: center;
    margin: 0;
    padding: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.notAvailableBold {
  @include t.text(16px, 20px, 600);
}

.notAvailableNormal {
  @include t.text(14px, 22px, 400);
}
